// extracted by mini-css-extract-plugin
export default {"acc_component":"AccordionSub_acc_component__6Wd8k","div":"AccordionSub_div__A3GMt"};